<!--<ng-progress [spinner]="true" [thick]="true" [color]="'var(--primary-color)'"></ng-progress>-->



<!-- Loader visual: aparece solo si el progress bar está activo -->
<div class="loader-wrapper" *ngIf="isLoading">
  <div class="loader">
    <div class="loader-dot"></div>
    <div class="loader-dot"></div>
    <div class="loader-dot"></div>
    <div class="loader-dot"></div>
  </div>
</div>


<main>
    <router-outlet></router-outlet>
    <msc-toast></msc-toast>
</main>
